module.exports = __webpack_public_path__ + "static/media/r2h.175c9dae.png";